// DOM取得
const tabMenus = document.querySelectorAll(".p-rooms-tab li");
// イベント付加
tabMenus.forEach((tabMenu) => {
  tabMenu.addEventListener("click", tabSwitch);
});
// イベントの処理
function tabSwitch(e) {
  // クリックされた要素のデータ属性を取得
  const tabTargetData = e.currentTarget.dataset.tab;

  // クリックされた要素の親要素と、その子要素を取得
  const tabList = e.currentTarget.closest(".p-rooms-tab");
  const tabItems = tabList.querySelectorAll(".p-rooms-tab li");

  // クリックされた要素の兄弟要素の子要素を取得
  const tabPanelItems = document.querySelectorAll(".p-rooms-type__contents");

  // タブの切り替え
  tabItems.forEach((tabItem) => {
    tabItem.classList.remove("current");
  });

  tabPanelItems.forEach((tabPanelItem) => {
    tabPanelItem.classList.remove("current");
  });

  // クリックされたtabにクラスを付与
  e.currentTarget.classList.add("current");

  // アニメーションを完了してから次のタブを表示
  tabPanelItems.forEach((tabPanelItem) => {
    if (tabPanelItem.dataset.panel === tabTargetData) {
      tabPanelItem.classList.add("current");
    }
  });
}

//スマホのみコンテンツまでスクロール
document.addEventListener("DOMContentLoaded", function () {
  const tabItems = document.querySelectorAll(".p-rooms-tab li");

  tabItems.forEach(function (item) {
    item.addEventListener("click", function () {
      // スマホ判定（768px以下）
      if (window.innerWidth <= 768) {
        const target = document.querySelector(".p-rooms-type");
        const header = document.querySelector(".l-header");

        if (!target) return;

        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const margin = 40; // さらに余白を足す場合

        const scrollPosition =
          target.getBoundingClientRect().top +
          window.scrollY -
          headerHeight -
          margin;

        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    });
  });
});
